import React, { ReactNode } from "react";
import clsx from "clsx";
import { Box } from "@material-ui/core";

import useStyles from "./FormFieldset.style";

const FormFieldset = ({
  children,
  className,
  ariaLabelledBy,
  component = "div",
}: {
  children: ReactNode;
  className?: string;
  ariaLabelledBy?: string;
  component?: React.ElementType;
}) => {
  const c = useStyles({});
  const resolvedComponent = ariaLabelledBy && component === "div" ? "fieldset" : component;

  return (
    <Box
      className={clsx(c.root, className, "form-fieldset")}
      aria-labelledby={ariaLabelledBy}
      component={resolvedComponent}
    >
      {children}
    </Box>
  );
};

export { FormFieldset };
